import { Reducer } from 'redux';

import { mapKeyToData } from '../../../utils';
import {
  GET_SCALES_REQUEST,
  GET_SCALES_SUCCESS,
  GET_SCALES_FAILED,
  GET_SCALE_REQUEST,
  GET_SCALE_SUCCESS,
  GET_SCALE_FAILED,
  RESET_SCALES,
  ADD_SCALE_REQUEST,
  ADD_SCALE_SUCCESS,
  ADD_SCALE_FAILED,
  EDIT_SCALE_REQUEST,
  EDIT_SCALE_SUCCESS,
  EDIT_SCALE_FAILED,
  DELETE_SCALE_REQUEST,
  DELETE_SCALE_SUCCESS,
  DELETE_SCALE_FAILED,
} from '../constants/actionTypes';
import { Scale, ScalesRespI } from '../../../interfaces/scale.interface';
import { ThunkSuccessAction, ThunkFailAction } from '../../../services/apiMiddleware';
import { PaginationI } from '../../../interfaces/pagination.interface';

export interface ScalesState {
  loadingScales: boolean;
  loadingScale: boolean;
  loadingAdd: boolean;
  loadingEdit: boolean;
  loadingDel: boolean;
  errorDel: boolean;
  items: Scale[];
  item: Scale | null;
  pagination: PaginationI | null;
  byId: { [key: string]: Scale };
}

export function getInitialScalesState(): ScalesState {
  return {
    loadingScales: false,
    loadingScale: false,
    loadingAdd: false,
    loadingEdit: false,
    loadingDel: false,
    errorDel: false,
    items: [],
    pagination: null,
    item: null,
    byId: {},
  };
}

const scalesReducer: Reducer<ScalesState, ThunkSuccessAction | ThunkFailAction> = (
  state = getInitialScalesState(),
  action,
) => {
  switch (action.type) {
    case GET_SCALES_REQUEST:
      return {
        ...state,
        loadingScales: true,
      };
    case GET_SCALES_SUCCESS:
      return {
        ...state,
        loadingScales: false,
        items: (action as ThunkSuccessAction<ScalesRespI>).response.data.items,
        pagination: action.response.data.pagination,
        byId: mapKeyToData(
          action.response.data.items,
          action.withVersions || action.includeDeleted ? 'versionId' : 'id',
        ),
      };
    case GET_SCALES_FAILED:
      return {
        ...state,
        loadingScales: false,
      };
    case GET_SCALE_REQUEST:
      return {
        ...state,
        loadingScale: true,
      };
    case GET_SCALE_SUCCESS:
      return {
        ...state,
        loadingScale: false,
        item: (action as ThunkSuccessAction<Scale>).response.data,
      };
    case GET_SCALE_FAILED:
      return {
        ...state,
        loadingScale: false,
      };
    case RESET_SCALES:
      return {
        ...state,
        items: [],
      };
    case ADD_SCALE_REQUEST:
      return {
        ...state,
        loadingAdd: true,
      };
    case ADD_SCALE_SUCCESS:
      return {
        ...state,
        loadingAdd: false,
      };
    case ADD_SCALE_FAILED:
      return {
        ...state,
        loadingAdd: false,
      };
    case EDIT_SCALE_REQUEST:
      return {
        ...state,
        loadingEdit: true,
      };
    case EDIT_SCALE_SUCCESS:
      return {
        ...state,
        loadingEdit: false,
        item: action.response.data,
      };
    case EDIT_SCALE_FAILED:
      return {
        ...state,
        loadingEdit: false,
      };
    case DELETE_SCALE_REQUEST:
      return {
        ...state,
        loadingDel: true,
        errorDel: false,
      };
    case DELETE_SCALE_SUCCESS:
      return {
        ...state,
        loadingDel: false,
      };
    case DELETE_SCALE_FAILED:
      return {
        ...state,
        loadingDel: false,
        errorDel: (action as ThunkFailAction).error.response
          ? action.error.response.data.translation_key
          : '',
      };
    default:
      return state;
  }
};

export default scalesReducer;
